import { render, staticRenderFns } from "./lvshouMeiXueGuan.vue?vue&type=template&id=098bb3b4&scoped=true"
import script from "./lvshouMeiXueGuan.vue?vue&type=script&lang=js"
export * from "./lvshouMeiXueGuan.vue?vue&type=script&lang=js"
import style0 from "./lvshouMeiXueGuan.vue?vue&type=style&index=0&id=098bb3b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098bb3b4",
  null
  
)

export default component.exports